import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "33",
  height: "34",
  viewBox: "0 0 33 34",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M0.665527 1.17188L32.6655 33.1719",
      stroke: "#D9D9D9",
      "stroke-width": "0.75",
      "stroke-miterlimit": "10"
    }, null, -1),
    _createElementVNode("path", {
      d: "M32.6655 1.17188L0.665527 33.1719",
      stroke: "#D9D9D9",
      "stroke-width": "0.75",
      "stroke-miterlimit": "10"
    }, null, -1)
  ]))]))
}
export default { render: render }